import { gql } from '@apollo/client';

import {
  TXN_FIELDS,
  TXN_LINE_FIELDS,
  TXN_ACCOUNT_FIELDS,
} from '../Txns/queries';

export const PAYMENT_SELECTS = gql`
  ${TXN_FIELDS}
  ${TXN_LINE_FIELDS}
  ${TXN_ACCOUNT_FIELDS}
  query NoUserLogPaymentSelects(
    $ids: [ID!]
    $entityType: String
    $entityId: ID
  ) {
    invoiceLines: txnLines(
      scopes: ["unpaid_invoice"]
      entityType: $entityType
      entityId: $entityId
    ) {
      ...TxnLineFields
      amount
      openBalance
      txn {
        ...TxnFields
      }
    }
    existingInvoiceLines: txnLines(ids: $ids) {
      ...TxnLineFields
      amount
      openBalance
      txn {
        ...TxnFields
      }
    }
    accounts(scopes: ["includeHidden"]) {
      ...TxnAccountFields
    }
  }
`;

export const TXN_BY_REFERENCE = gql`
  ${TXN_FIELDS}
  query TxnByReference($reference: String!) {
    txnByReference(reference: $reference) {
      ...TxnFields
      openBalance
      bankLine { id }
    }
  }
`;
